export { default } from "./ChallengesActivityIcon";
